import languages from "./languages";

const lang = {
  header: {
    home: "ホーム",
  },
  message: {
    touchToUpdate: "イメージをクリックすると再度生成します。",
    resources: "Resources",
  },
  mint: {
    switchNetwork: "ネットワークを切り替えて下さい。",
    switchNetworkButton: "ネットワーク切り替え",
    connectMetamask: "Metamaskと接続してください。",
  },
  languages,
};

export default lang;
